import { use } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { env } from "@/src/common/constants/env";
import * as en from "@/src/common/locales/en";
import * as es from "@/src/common/locales/es";

const resources = {
	en,
	es,
};

export const LANGUAGES = {
	en: "English",
	es: "Español",
} as const;

export type Language = keyof typeof LANGUAGES;

export const NAMESPACES = {
	common: "common",
	auth: "auth",
	dashboard: "dashboard",
	jobs: "jobs",
	post: "post",
	profile: "profile",
	staffs: "staffs",
	students: "students",
	studentCentral: "studentCentral",
	schools: "schools",
	groups: "groups",
	messaging: "messaging",
	notifications: "notifications",
	analytics: "analytics",
	aiAssistant: "aiAssistant",
	audit: "audit",
	reports: "reports",
	resume: "resume",
	childcare: "childcare",
} as const;

export type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = "en";
export const DEFAULT_NAMESPACE: Namespace = "common";

use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		ns: Object.values(NAMESPACES),
		defaultNS: DEFAULT_NAMESPACE,
		fallbackNS: DEFAULT_NAMESPACE,
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: Object.keys(LANGUAGES),
		interpolation: {
			escapeValue: false,
			defaultVariables: { appName: env.APP_NAME },
		},
		react: {
			useSuspense: true,
		},
		nsSeparator: ":",
		keySeparator: ".",
		detection: {
			order: ["cookie", "navigator"],
			lookupCookie: "app-locale",
			caches: ["cookie"],
		},
	});

export { default } from "i18next";
